import { createContext } from 'react';

import { initialState } from './GetHelpZendeskReducer.ts';
import { type DispatchType, type State } from './GetHelpZendeskTypes.ts';

const GetHelpZendeskContext = createContext<{
    dispatch: DispatchType;
    state: State;
}>({ dispatch: () => {}, state: initialState });

export { GetHelpZendeskContext };
